import { CenterContentInterface } from '~/payload-types';

import LexicalRenderer from '../LexicalRenderer';

type Props = CenterContentInterface & {};

export default function CenterContentBlock(props: Props) {
  return (
    <LexicalRenderer data={props.content} className="flex w-full  items-center justify-center" />
  );
}
